import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';

export default function TaraanayaTest() {
  const [formData, setFormData] = useState({
    name: 'Mandeep Singh',
    dateOfBirth: '1997-05-14',
    timeOfBirth: '12:17',
    placeOfBirth: 'Delhi, India',
    apiKey: ''
  });
  
  const [documents, setDocuments] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (documents.length !== 8) {
      setError('Please upload exactly 8 domain documents (PDFs)');
      return;
    }
    
    if (!formData.apiKey || formData.apiKey.length < 10) {
      setError('Please enter a valid OpenAI API key');
      return;
    }
    
    setIsProcessing(true);
    setError('');
    setResults(null);
    
    try {
      const form = new FormData();
      form.append('name', formData.name);
      form.append('date_of_birth', formData.dateOfBirth);
      form.append('time_of_birth', formData.timeOfBirth);
      form.append('place_of_birth', formData.placeOfBirth);
      form.append('provider', 'openai');
      form.append('model', 'gpt-4o-mini');
      form.append('api_key', formData.apiKey);
      
      documents.forEach(doc => {
        form.append('documents', doc);
      });
      
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'https://taraanaya-prod-production.up.railway.app';
      const response = await fetch(`${backendUrl}/api/taraanaya/complete-prediction`, {
        method: 'POST',
        body: form
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Prediction failed');
      }
      
      const data = await response.json();
      setResults(data);
      
    } catch (err) {
      setError(err.message || 'Failed to generate prediction');
    } finally {
      setIsProcessing(false);
    }
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold text-white mb-8">
          ⭐ Taraanaya Complete - 8 Domain Test
        </h1>
        
        {!results ? (
          <form onSubmit={handleSubmit} className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-purple-500/20 p-8 space-y-6">
            {/* Birth Details */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-white mb-2">Name</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600"
                  required
                />
              </div>
              
              <div>
                <label className="block text-white mb-2">Date of Birth</label>
                <input
                  type="date"
                  value={formData.dateOfBirth}
                  onChange={(e) => setFormData({...formData, dateOfBirth: e.target.value})}
                  className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600"
                  required
                />
              </div>
              
              <div>
                <label className="block text-white mb-2">Time of Birth</label>
                <input
                  type="time"
                  value={formData.timeOfBirth}
                  onChange={(e) => setFormData({...formData, timeOfBirth: e.target.value})}
                  className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600"
                  required
                />
              </div>
              
              <div>
                <label className="block text-white mb-2">Place of Birth</label>
                <input
                  type="text"
                  value={formData.placeOfBirth}
                  onChange={(e) => setFormData({...formData, placeOfBirth: e.target.value})}
                  className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600"
                  required
                />
              </div>
            </div>
            
            {/* API Key */}
            <div>
              <label className="block text-white mb-2">OpenAI API Key (Required)</label>
              <input
                type="password"
                value={formData.apiKey}
                onChange={(e) => setFormData({...formData, apiKey: e.target.value})}
                className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600"
                placeholder="sk-..."
                required
              />
            </div>
            
            {/* Documents Upload */}
            <div>
              <label className="block text-white mb-2">
                Upload 8 Domain Documents (PDFs) - {documents.length}/8
              </label>
              <input
                type="file"
                accept=".pdf"
                multiple
                onChange={(e) => setDocuments(Array.from(e.target.files).slice(0, 8))}
                className="w-full bg-slate-700 text-white px-4 py-2 rounded-lg border border-slate-600"
              />
              <p className="text-sm text-gray-400 mt-2">
                Order: Health, Career, Wealth, Business, Family, Education, Travel, Marriage
              </p>
            </div>
            
            {error && (
              <div className="bg-red-500/20 border border-red-500 text-red-200 px-4 py-3 rounded-lg">
                {error}
              </div>
            )}
            
            <button
              type="submit"
              disabled={isProcessing || documents.length !== 8}
              className="w-full bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-bold py-4 px-6 rounded-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-3"
            >
              {isProcessing ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  Generating 8 Domain Predictions...
                </>
              ) : (
                <>🚀 Get Complete Prediction (Target: &lt;10s)</>
              )}
            </button>
          </form>
        ) : (
          <div className="space-y-6">
            {/* Summary */}
            <div className="bg-green-500/20 border border-green-500 text-green-200 px-6 py-4 rounded-lg">
              <h2 className="text-2xl font-bold mb-2">✅ Prediction Complete!</h2>
              <p>Time: {results.summary.total_time_seconds}s | Success: {results.summary.successful_domains}/8 domains | Output: {results.summary.total_output_length} chars</p>
            </div>
            
            {/* All Domain Results */}
            <div className="grid grid-cols-1 gap-6">
              {Object.entries(results.predictions).map(([key, domain]) => (
                <div key={key} className="bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-purple-500/20 p-6">
                  <h3 className="text-2xl font-bold text-white mb-4">
                    {domain.name} {domain.error ? '❌' : '✅'}
                  </h3>
                  <div className="text-gray-300 whitespace-pre-wrap">
                    {domain.prediction}
                  </div>
                  {domain.length && (
                    <p className="text-sm text-gray-500 mt-4">{domain.length} characters</p>
                  )}
                </div>
              ))}
            </div>
            
            <button
              onClick={() => setResults(null)}
              className="w-full bg-slate-700 hover:bg-slate-600 text-white font-bold py-3 px-6 rounded-xl transition-all"
            >
              ← Generate Another Prediction
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
